import React, { Fragment, useCallback } from 'react';
import { observer } from 'mobx-react';
import classNames from 'classnames';
import Tooltip from '@material-ui/core/Tooltip';
import VideocamOff from '@material-ui/icons/VideocamOff';

import { translate } from 'services/i18nService';
import ProfileStore from 'stores/ProfileStore';
import Button from 'components/Button/Button';

import styles from './ProfileBanner.css';


function HideStreamButton() {
  const { hideProfileStream } = ProfileStore;
  const onHideStream = useCallback(() => {
    ProfileStore.toggleHideProfileStream();
  }, []);

  const indicatorClass = classNames({
    [styles.indicator]: true,
    [styles.indicatorOn]: hideProfileStream,
  });

  return (
    <Fragment>
      <div className={styles.broadcasterHelperText}>
        {translate('v2profile.this.is.your.room')}
      </div>
      <Tooltip title={translate('v2profile.hide.stream.preview')}>
        <div>
          <Button
            className={styles.hideStreamBtn}
            colour="white"
            icon={
              <Fragment>
                <div className={indicatorClass} />
                <VideocamOff className={styles.camIcon} />
              </Fragment>
            }
            id="hideProfileStreamButton"
            onClick={onHideStream}
          />
        </div>
      </Tooltip>
    </Fragment>
  );
}

export default observer(HideStreamButton);
